module.exports = __webpack_public_path__ + "img/create-landing-cover.8c616149.gif";